module.exports = __webpack_public_path__ + "static/media/arrowKeys.4fc90e8b.png";